import React from 'react';
import { LockIcon, ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { offerCards } from '../data/content';
import { CHECKOUT_URL } from '../utils/checkout';
import { trackAddToCart } from '../utils/metaPixel';
export function Offer() {
  return <section id="oferta" className="w-full scroll-mt-16 bg-cream py-16 sm:py-20" data-id="element-116" data-mp="1hofnlrzgt75y">
      <div className="mx-auto max-w-6xl px-5 sm:px-6" data-id="element-117" data-mp="1hqim70eoo8ma">
        <Reveal className="text-center" data-id="element-118" data-mp="tzwexbci6sdc">
          <h2 className="text-[26px] font-bold tracking-tight text-forest sm:text-[32px]" data-id="element-119" data-mp="u0xvtwg7a92z">
            Todo Lo Que Recibes Hoy
          </h2>
          <p className="mt-2 text-base text-warmgray" data-id="element-120" data-mp="13xaxphlwft8t">Un sistema completo — no solo un ebook.</p>
        </Reveal>

        <ul className="snap-x-mandatory mt-10 -mx-5 flex gap-4 overflow-x-auto px-5 pb-4 md:mx-0 md:grid md:grid-cols-2 md:overflow-visible md:px-0 md:pb-0 md:gap-6" data-id="element-121" data-mp="ywwkzm9crv4g">
          {offerCards.map((card, i) => <Reveal as="li" key={card.title} delay={i * 0.07} className="w-[85vw] max-w-sm shrink-0 snap-center md:w-auto md:max-w-none" data-id="element-122" data-mp="2ac1t55s96lvg" data-mpi={i}>
              <article className={`flex h-full flex-col rounded-2xl bg-white p-6 ${card.featured ? 'shadow-lg' : 'shadow-sm'}`} style={{
            borderLeft: `${card.borderWidth} solid ${card.borderColor}`
          }} data-id="element-123" data-mp="pmbfxskd704g">
                <span className={`inline-flex w-fit rounded-full px-3 py-1 text-[11px] font-bold tracking-wide ${card.badgeClass}`} data-id="element-124" data-mp="13k05hdpdmvfu">
                  {card.badge}
                </span>

                <div className="mt-5 flex justify-center" data-id="element-125" data-mp="6rwkgcx9hpld">
                  <img src={card.image} alt={card.imageAlt} className="max-h-40 w-auto rounded-lg object-contain shadow-md" loading="lazy" data-id="element-126" data-mp="btlrzil9zl4p" />
                </div>

                <h3 className={`mt-5 font-bold leading-snug tracking-tight ${card.titleClass}`} data-id="element-127" data-mp="klnsthz9b3fi">
                  {card.title}
                </h3>

                {card.subtitle && <p className="mt-1 text-sm font-medium text-warmgray" data-id="element-128" data-mp="3k6t426o0ix7r">{card.subtitle}</p>}

                <p className="mt-2 text-sm leading-relaxed text-charcoal/80" data-id="element-129" data-mp="3o84jxkh3442r">{card.description}</p>

                <p className="mt-auto pt-5 text-sm font-semibold text-forest" data-id="element-130" data-mp="vdnuyjol9t74">
                  <span className="text-warmgray line-through" data-id="element-131" data-mp="qg4hhlzptkg8">{card.value}</span>
                  <span className="mx-2 text-warmgray/50" data-id="element-132" data-mp="154imo3kltkzy">→</span>
                  Incluido hoy
                </p>
              </article>
            </Reveal>)}
        </ul>

        {/* Total value */}
        <Reveal delay={0.06} data-id="element-133" data-mp="cho1t5jvkjly">
          <div className="mx-auto mt-10 max-w-lg rounded-2xl bg-gold px-6 py-7 text-center" data-id="element-134" data-mp="ciz5z6h8ftdl">
            <p className="text-[18px] font-semibold text-forest line-through" data-id="element-135" data-mp="7jmicjijei9y">Valor total: $238 USD</p>
            <p className="mt-1 text-[32px] font-bold tracking-tight text-forest sm:text-[36px]" data-id="element-136" data-mp="lfghwbxf7vae">
              Tu precio hoy: $9.99 USD
            </p>
            <p className="mt-1 text-sm font-semibold text-forest/80" data-id="element-137" data-mp="1wvyeqd4xjzxk">
              Ahorro del 96% — Precio de lanzamiento
            </p>
          </div>
        </Reveal>

        {/* CTA #1 */}
        <Reveal delay={0.1} className="mt-8 flex flex-col items-center" data-id="element-138" data-mp="20e47virh80kv">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="flex min-h-14 w-full max-w-lg items-center justify-center rounded-2xl bg-coral px-6 py-4 text-center text-base font-bold leading-tight text-white shadow-xl transition-transform duration-150 ease-out hover:scale-[1.02] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-forest sm:text-lg" data-id="element-139" data-mp="25dqpe4ec82zh">
            QUIERO TODO ESTO POR $9.99 USD — ACCESO INMEDIATO →
          </a>

          <p className="mt-3 flex items-center gap-1.5 text-xs text-warmgray" data-id="element-140" data-mp="29g3tkodfrsu5">
            <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-141" data-mp="2ee5ap3raxi2z" />
            Pago único · Descarga instantánea · Garantía 07 días
          </p>
          <p className="mt-1.5 flex items-center gap-1.5 text-xs font-semibold text-forest" data-id="element-142" data-mp="3237sqcpulcy0">
            <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-143" data-mp="36vhmk3u32x5k" />
            Sin riesgo
          </p>
        </Reveal>
      </div>
    </section>;
}